import { h } from 'preact';

export default props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
		<path d="M3.33301 5.83333H11.6663C14.4278 5.83333 16.6663 8.07191 16.6663 10.8333C16.6663 13.5948 14.4278 15.8333 11.6663 15.8333H3.33301M3.33301 5.83333L6.66634 2.5M3.33301 5.83333L6.66634 9.16667" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
);
